import { useContext } from "react";
import { ApplicantContext } from "../providers/ApplicantProvider";

export default function useApplicants() {
  const context = useContext(ApplicantContext);

  if (!context) {
    throw new Error(
      "useApplicants must be used inside ApplicantProvider."
    );
  }

  return context;
}